export interface IUserGroupListItemUser {
    id: string;
    name: string;
    disabled: boolean;
}

export class UserGroupListItemUser implements IUserGroupListItemUser {
    id: string;
    name: string;
    disabled: boolean;

    constructor();
    constructor(obj: IUserGroupListItemUser);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.disabled = obj && obj.disabled || false;
    }
}